import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { UploadIcon, PlusIcon } from 'lucide-react';
interface ImageUploaderProps {
  onImageUpload: (imageData: string) => void;
  hasImage: boolean;
}
export function ImageUploader({
  onImageUpload,
  hasImage
}: ImageUploaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = event => {
        const imageData = event.target?.result as string;
        onImageUpload(imageData);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = event => {
        const imageData = event.target?.result as string;
        onImageUpload(imageData);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };
  return <div className="space-y-4" data-id="element-86">
      <h3 className="text-sm font-medium text-gray-700 uppercase tracking-wide" data-id="element-87">
        {hasImage ? 'Add Another Design' : 'Upload Design'}
      </h3>

      <motion.div onDrop={handleDrop} onDragOver={handleDragOver} onClick={() => fileInputRef.current?.click()} className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-gray-400 hover:bg-gray-50 transition-colors" whileHover={{
      scale: 1.01
    }} whileTap={{
      scale: 0.99
    }} data-id="element-88">
        <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileChange} className="hidden" data-id="element-89" />

        <div className="flex flex-col items-center gap-3" data-id="element-90">
          {hasImage ? <>
              <PlusIcon className="w-10 h-10 text-blue-500" data-id="element-91" />
              <p className="text-sm font-medium text-gray-700" data-id="element-92">Add New Layer</p>
              <p className="text-xs text-gray-500" data-id="element-93">
                Drop image or click to browse
              </p>
            </> : <>
              <UploadIcon className="w-10 h-10 text-gray-400" data-id="element-94" />
              <p className="text-sm font-medium text-gray-700" data-id="element-95">
                Drop image here
              </p>
              <p className="text-xs text-gray-500" data-id="element-96">or click to browse</p>
            </>}
        </div>
      </motion.div>
    </div>;
}